import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=4a4dff02&"
import script from "./Car.vue?vue&type=script&lang=js&"
export * from "./Car.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Car.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "47b3f469"
  
)

export default component.exports